import { VenueOperatorContactPersonType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { ContactPersonsHeader, ContactPersonsTableRow } from './components';

type ContactPersonsTablePropsType = {
  contactPersons: VenueOperatorContactPersonType[];
};

export const ContactPersonsTable: React.FC<ContactPersonsTablePropsType> = ({
  contactPersons,
}) => {
  if (contactPersons.length === 0) return null;

  return (
    <TouringCardTable>
      <ContactPersonsHeader />
      <TouringCardTableBody>
        {contactPersons.map((contactPerson) => (
          <ContactPersonsTableRow
            key={contactPerson.person.id}
            contactPerson={contactPerson}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
